import React from 'react'
import { theme } from './Theme'
import Modal from "react-modal"


const CustomModal = (props) =>{
    return(
        <>
        {props.isModalOpen === true &&
           
            <Modal
            isOpen={props.isModalOpen}
            onRequestClose={props.onClose}
            contentLabel="Reqest Service"
            className="customModal"
            overlayClassName="customModalOverlay"
            style={{
                overlay: {
                    position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
                    backgroundColor: theme.colors.dark + `aa`,
                    zIndex: 2,
                },
                content: {
                    position: 'absolute',
                    overflow: 'auto',
      WebkitOverflowScrolling: 'touch',
      outline: 'none',
      padding: '20px 40px',
                    background: theme.colors.primary,
                    color: theme.colors.light,
                    top: `50%`,
                    left: `50%`,
                    right: `auto`,
                    bottom: `auto`,
                    transform: `translate(-50%, -50%)`,

                }
            }}
            closeTimeoutMS={500}
            >
            <button 
            className='closeButton'
            onClick={props.onClose}
            >
                x
            </button>
            <div className="modalContentContainer">
            {props.modalContent}
            </div>
            </Modal>
        
        }
       </> 
    )
   
}
export {CustomModal}